import { ControlTemplate } from 'dac-web-ui';
import css from './loading.module.css';
import html from './loading.module.html';

//loaders from https://css-loaders.com/
export class Loading extends ControlTemplate {

	constructor( containerId) {
		super();
		this.containerId = containerId;
	}

	show() {

		//add css
		let idcss = 'loadingpanel';
        
		//remove
		let old = document.head.querySelector( '#' + idcss );
		if( old ) old.parentNode.removeChild( old );

		//add
		let styleSheet = document.createElement( 'style' );
		styleSheet.id = idcss;
		styleSheet.type = 'text/css';
		styleSheet.innerText = css;

		document.head.appendChild( styleSheet );

		//add html
		this._html = this._strToHTML( html ); 
		this.container = document.getElementById( this.containerId );
		if( this.container ) this.container.appendChild( this._html );
		else document.body.appendChild( this._html );
	}

	hide() {

		//remove css
		let idcss = 'loadingpanel';
		let old = document.head.querySelector( '#' + idcss );
		if( old ) old.parentNode.removeChild( old );

		//remove html
		if( this._html.parentNode) this._html.parentNode.removeChild( this._html );
		delete this._html;
	}
}